
import { defineStore } from 'pinia';

export const useWeatherDisplayStore = defineStore('weatherDisplay', {
  state: () => ({
    currentLocation: null, // { lat, lon, name, country, admin1, admin2 }
    deviceLocation: null, // { lat, lon, fetchedAt }
  }),
  actions: {
    setCurrentLocation(location) {
      this.currentLocation = location;
    },
    setDeviceLocation(location) {
      this.deviceLocation = location;
    },
  },
});
